import styled from 'styled-components';

const ButtonRow = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 1rem;
`;

export default ButtonRow;
